import "@fortawesome/fontawesome-free/css/all.min.css";
import React, { useEffect, useState } from "react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useHeaderContext } from "../context/HeaderHoverContext";
import "../styles/Header.css";
import "../styles/SliderTop.css";

const SliderTop = ({ sliderImages }) => {
  const { isHeaderHovered } = useHeaderContext();
  const [animate, setAnimate] = useState(false);

  const handleSlideChange = () => {
    setAnimate(false);
    setTimeout(() => setAnimate(true), 50);
  };

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <div className="slider-top">
      <Swiper
        className="swiper-nav"
        modules={[Autoplay, Navigation, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        navigation={true}
        pagination={{ clickable: true }}
        onSlideChange={handleSlideChange}
      >
        {sliderImages.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="swiper-slide-content"
              style={{
                transition: "opacity 0.9s ease, filter 0.3s ease",
                backgroundImage: `linear-gradient(
                  to bottom,
                  rgba(0, 0, 0, ${isHeaderHovered ? 0.1 : 0}) 100%,
                  rgba(0, 0, 0, ${isHeaderHovered ? 0.3 : 0}) 30%,
                  rgba(0, 0, 0, 0) 0%,                             
                  rgba(0, 0, 0, 0) 0%                             
                ), url(${slide.url})`,
                filter: isHeaderHovered
                  ? "brightness(75%)"
                  : "brightness(100%)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div className={`text-overlay ${slide.position}`}>
                <h1>
                  <span
                    className={`slide-subtitle ${
                      animate ? "circularOpacityEffectLight" : ""
                    }`}
                  >
                    {slide.span1}
                  </span>
                  <br />
                  <span
                    className={`slide-title ${
                      animate ? "circularOpacityEffect" : ""
                    }`}
                  >
                    {slide.title}
                  </span>
                </h1>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <svg
        className="wave-svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
      >
        <path
          fill="white"
          fillOpacity="1"
          d="M0,305L60,300C120,295,240,285,360,280C480,275,600,280,720,285C840,290,960,290,1080,280C1200,270,1320,260,1380,255L1440,253L1440,330L1380,330C1320,330,1200,330,1080,330C960,330,840,330,720,330C600,330,480,330,360,330C240,330,120,330,60,330L0,330Z"
        ></path>
      </svg>
    </div>
  );
};

export default SliderTop;
